<template>
  <div class="djs">
    <div class="djs_left">
<!--      {{ labelName }}<template v-if="timeLimit">（{{ getTimeDesc }}）</template>-->
    </div>
    <div class="djs_right">
      距离结束
      <VanCountDown  class="ending" :format="getCountDownFormat" @finish="$emit('finish')" :time="time" />
    </div>
  </div>
</template>
<script>
import { CountDown as VanCountDown } from "vant"
import Moment from "moment"

export default {
  name: "CountDown",
  props: {
    time: Number,
    labelName: String,
    timeLimit: String
  },
  components: { VanCountDown },
  computed: {
    getTimeDesc() {
      let timeLimit = this.timeLimit;
      if (!timeLimit || !timeLimit.includes('-')) return
      let sfmArr = timeLimit.split('-')
      return this.getHourAndMimute(sfmArr[0]) + '-' + this.getHourAndMimute(sfmArr[1])
    },
    getCountDownFormat() {
      if (this.time > 24 * 60 * 60 * 1000) {
        return "DD天HH小时"
      } else {
        return "HH:mm:ss"
      }
    }
  },
  methods: {
    StartIntertime() {
      // 处理vant版本低不能用change方法，替换format
      let myTime = this.time
      if (myTime >= 24 * 60 * 60 * 1000) {
        let myIntervalTime = setInterval(() => {
          if (myTime>=0) {
            myTime = myTime - 1000
            this.$emit("getTime", myTime)
          } else {
            myTime = 0
            clearInterval(myIntervalTime)
          }
        }, 1000)
      }
    },
    getHourAndMimute(val) {
      let hourMinute = val.split(':')
      if (hourMinute.length >= 2) {
        return hourMinute[0] + ":" + hourMinute[1]
      } else {
        console.warn("请检查日期格式")
      }
    },
  }
}

</script>
<style lang="scss" scoped>
.djs {
  width: 100%;
  height: 45px;
  background: url("./img/djs_bg.png") no-repeat;
  background-size: cover;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &_left {
    flex: 1;
    font-size: 14px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #ffffff;
    line-height: 17px;
    text-shadow: 0px 1px 2px rgba(127, 6, 38, 0.2);
  }
  &_right {
    font-size: 10px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #fbe5c5;
    border: 1px solid #fadcbf;
    border-radius: 20px;
    padding: 5px 7px;
    flex-shrink: 0;
    .ending {
      display: inline;
      color: #fbe5c5;
      font-size: 10px;
      font-weight: 400;
      line-height: 17px;
    }
  }
}
</style>
